// Componente BodyDashboard - Refatorado para usar estrutura modular
import React from "react";
import { ToastContainer } from "react-toastify";
import Camouflage from "./components/camouflage/camouflage";
import DashboardContent from "./components/DashboardContent";
import { useDashboard } from "./hooks/useDashboard";

/**
 * Componente BodyDashboard - Corpo principal do Dashboard
 * Utiliza hooks customizados e componentes modulares para manter
 * o código organizado e reutilizável
 */
function BodyDashboard() {
  const {
    loading,
    camouflage,
    showCards,
    enablePlague,
    plagueSelected,
    plots,
    hectar,
    alto,
    medio,
    baixo,
    plagues,
    municipality,
    handleViewCards,
    handleChangeMunicipio,
    handleChangePlague
  } = useDashboard();

  // Mostrar camuflagem enquanto carrega ou se não houver dados
  if (camouflage || loading) {
    return <Camouflage />;
  }

  return (
    <>
      <DashboardContent
        hectar={hectar}
        alto={alto}
        medio={medio}
        baixo={baixo}
        plagues={plagues}
        municipality={municipality}
        showCards={showCards}
        enablePlague={enablePlague}
        plagueSelected={plagueSelected}
        plots={plots}
        onViewCards={handleViewCards}
        onChangeMunicipio={handleChangeMunicipio}
        onChangePlague={handleChangePlague}
      />
      <ToastContainer />
    </>
  );
}

export default BodyDashboard;

